import { useState, useEffect } from 'react';
import './WorkWithUs.scss';
import cn from 'classnames';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
// import Image from './img1.jpg';
import Form from '../../components/Form';
import WhoWeHire from '../../components/WhoWeHire';

const WorkWithUsPage = ({ onFormClick }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isFormOpen, setFormOpen] = useState(false);

  const handleWindowSizeChange = () => {
    setIsMobile(window.innerWidth <= 1200);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [window.location.pathname]);

  useEffect(() => {
    setIsMobile(window.innerWidth <= 1200);
    window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return (
    <div className='page'>
      <Header onFormClick={() => setFormOpen(true)} />
      <div className='workWithUsHeader'>
        <span className='workWithUsTitle'>Who We Hire</span>
        <span className='workWithUsText'>
          At NextDeavor, we help companies of every size find the talent they need to grow. From technical innovators to
          people-first leaders, here are the areas we specialize in:
        </span>
      </div>
      <WhoWeHire withTitle={false} />
      <div className='workWithUsDescription'>
        <div className='workWithUsDescriptionContent'>
          <span className='workWithUsDescriptionContentText'>
            Whether you’re a high-growth startup, a mid-sized business, or an established enterprise, we bring expertise across a
            wide range of industries to help you scale. From advanced fields like High Tech, SaaS, Semiconductors, Defense,
            Energy, Robotics, and AI to dynamic sectors such as Real Estate, Property Management, and Advanced Manufacturing — we
            tailor our approach to your unique needs.
            <br />
            <br />
            <b>Because every great company deserves the right partner to grow with.</b>
            <br />
            <br />
            Let’s build your next chapter together.
          </span>
          <span className='workWithUsDescriptionContentImage'>{/* <img src={Image} /> */}</span>
        </div>
        <span className='workWithUsDescriptionButton' onClick={() => setFormOpen(true)}>
          Work With Us{' '}
          <svg xmlns='http://www.w3.org/2000/svg' width='36' height='36' viewBox='0 0 36 36' fill='none'>
            <path
              d='M18 3.375C15.1075 3.375 12.2799 4.23274 9.87479 5.83976C7.46972 7.44677 5.5952 9.73089 4.48827 12.4033C3.38134 15.0756 3.09171 18.0162 3.65602 20.8532C4.22033 23.6902 5.61323 26.2961 7.65857 28.3414C9.70391 30.3868 12.3098 31.7797 15.1468 32.344C17.9838 32.9083 20.9244 32.6187 23.5968 31.5117C26.2691 30.4048 28.5532 28.5303 30.1602 26.1252C31.7673 23.7201 32.625 20.8926 32.625 18C32.6209 14.1225 31.0788 10.4049 28.3369 7.66309C25.5951 4.92125 21.8775 3.37909 18 3.375ZM24.4209 18.7959L19.9209 23.2959C19.7098 23.507 19.4235 23.6256 19.125 23.6256C18.8265 23.6256 18.5402 23.507 18.3291 23.2959C18.118 23.0848 17.9994 22.7985 17.9994 22.5C17.9994 22.2015 18.118 21.9152 18.3291 21.7041L20.9095 19.125H12.375C12.0766 19.125 11.7905 19.0065 11.5795 18.7955C11.3685 18.5845 11.25 18.2984 11.25 18C11.25 17.7016 11.3685 17.4155 11.5795 17.2045C11.7905 16.9935 12.0766 16.875 12.375 16.875H20.9095L18.3291 14.2959C18.118 14.0848 17.9994 13.7985 17.9994 13.5C17.9994 13.2015 18.118 12.9152 18.3291 12.7041C18.5402 12.493 18.8265 12.3744 19.125 12.3744C19.4235 12.3744 19.7098 12.493 19.9209 12.7041L24.4209 17.2041C24.5255 17.3085 24.6085 17.4326 24.6651 17.5692C24.7218 17.7058 24.7509 17.8522 24.7509 18C24.7509 18.1478 24.7218 18.2942 24.6651 18.4308C24.6085 18.5674 24.5255 18.6915 24.4209 18.7959Z'
              fill='white'
            />
          </svg>
        </span>
      </div>
      <Footer />
      {isFormOpen && <Form onClose={() => setFormOpen(false)} />}
    </div>
  );
};

export default WorkWithUsPage;
